import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Device } from '../../../common/interfaces/item.interface';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { EventTypes } from '../event-types/event-types';
import { EventType } from '../event-types/event-type.interface';
import { SimpleProgrammingContext, SIMPLE_ACTIONS } from '../quickstart-simple.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { Event } from '../../../common/interfaces/event.interface';

@Component({
  templateUrl: './select-device.component.html',
  styleUrls: ['./select-device.component.less']
})
export class QSSimpleSelectDeviceComponent extends BaseRoutingComponent {

  private _searchText: string;

  private _eventType: Observable<EventType>;
  private _devices: Observable<Device[]>;

  constructor(
    private _route: ActivatedRoute,
    protected store: Store<{
      simpleProgramming: SimpleProgrammingContext
    }>,
    protected router: Router,
    private _shared: SharedProgrammingService
  ) {
    super();

    this._eventType = this._route.params
      .map((params: { type: string }) => {
        return EventTypes.find(et => et.route == params.type);
      });

    this._devices = Observable.combineLatest(
      this._eventType.filter(et => !!et).map(et => et.whitelist.map(wl => wl.proxy)),
      this.store.select(s => s.simpleProgramming.devices).filter(d => !!d),
      (whitelist, devices) => {
        return devices.filter(device => {
          return whitelist.indexOf(device.proxy) > -1;
        });
      }
    );
  }

  cancelClicked() {
    if (this.isForTrigger(this._route)) {
      this.goHome();
    } else {
      this.goToEvent();
    }
  }

  isDark(): boolean {
    return this.isForTrigger(this._route);
  }

  ngOnInit() {
    this._devices
      .filter(devices => !!devices && devices.length == 1)
      .take(1)
      .subscribe(devices => {
        setTimeout(() => {
          this.router.navigate(['../device', devices[0].id], {
            skipLocationChange: true,
            relativeTo: this._route
          })
        }, 100);

      })
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/select-device/select-device.component.ts